import { XLSB_MIME_TYPE } from '@erp/shared-utils';

import type { TranslateFn, UploadFileRejection } from 'src/lib/pricelist-utils';
import { describeReceivedFileType } from 'src/lib/pricelist-utils';

/**
 * Classic IBM i Client Access `.xls`, modern `.xlsx`, and the `.xlsb` users
 * re-save the largest reports as.
 */
export const DAILY_REPORT_ACCEPT = `.xls,.xlsx,.xlsb,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,${XLSB_MIME_TYPE}`;

export function isDailyReportExcelFile(file: File): boolean {
  return /\.(xlsx|xls|xlsb)$/i.test(file.name);
}

export function isXlsbFile(file: File): boolean {
  return /\.xlsb$/i.test(file.name);
}

export function validateDailyReportFile(
  file: File,
  gt: TranslateFn,
): UploadFileRejection | null {
  if (isDailyReportExcelFile(file)) return null;
  return {
    kind: 'unsupported',
    title: gt('Unsupported file format', {
      context: 'toast title when an unsupported file type is selected',
    }),
    message: `${gt('Got a file of type', {
      context:
        'prefix before the type of an unsupported file the user tried to upload',
    })} “${describeReceivedFileType(file)}”. ${gt(
      'Please upload a file ending in .xls, .xlsx, or .xlsb.',
      {
        context:
          'toast message listing the supported daily-report Excel formats',
      },
    )}`,
  };
}
